import { createAction } from '@reduxjs/toolkit'

export const createCategory = createAction('settings/createCategory')
export const editCategory = createAction('settings/editCategory')
export const deleteCategory = createAction('settings/deleteCategory')
export const getMarketingCopy = createAction('settings/getMarketingCopy')
export const updateMarketingCopy = createAction('settings/updateMarketingCopy')
